import { useState, useCallback, useEffect, type RefObject } from 'react'

/**
 * Returns whether the element attached to the given ref is currently hovered.
 */
export function useHover<T extends HTMLElement>(elementRef: RefObject<T | null>): boolean {
    const [isHovering, setIsHovering] = useState(false)

    const handleMouseEnter = useCallback(() => setIsHovering(true), [])
    const handleMouseLeave = useCallback(() => setIsHovering(false), [])

    useEffect(() => {
        const el = elementRef.current
        if (!el) {
            return
        }
        el.addEventListener('mouseenter', handleMouseEnter)
        el.addEventListener('mouseleave', handleMouseLeave)
        return () => {
            el.removeEventListener('mouseenter', handleMouseEnter)
            el.removeEventListener('mouseleave', handleMouseLeave)
        }
    }, [elementRef, handleMouseEnter, handleMouseLeave])

    return isHovering
}
